import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.Applications.deleteDeviceConfirmTitle'),
      "open": _vm.deletePrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('NiotaClassic.Common.deleteButton'),
        color: _vm.color,
        emit: 'delete'
      }],
      "showSelect": _vm.isActility,
      "checkBoxLable": _vm.$i18n_t('NiotaClassic.Devices.deleteFromActility')
    },
    on: {
      "cancel": _vm.closeDeletePrompt,
      "delete": _vm.deleteDevice,
      "is-selectecd": _vm.deleteFromRemote
    }
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Applications.deleteDeviceConfirmInfo')))])]), _c('p', [_vm._v(_vm._s(_vm.selectedItem.title) + " (ID: " + _vm._s(_vm.selectedItem.id) + ")")])]), _c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.deviceFormDialog,
      callback: function ($$v) {
        _vm.deviceFormDialog = $$v;
      },
      expression: "deviceFormDialog"
    }
  }, [_vm.deviceFormDialog ? _c('niota-classic-devices-edit-form', {
    attrs: {
      "editedItem": _vm.editedDevice,
      "deviceTypes": _vm.deviceTypes,
      "applications": _vm.applications
    },
    on: {
      "close": _vm.toggleEditDeviceDialog,
      "refreshList": _vm.refreshList
    }
  }) : _vm._e()], 1), _vm.createDeviceDialog ? _c('niota-classic-applications-add-device', {
    on: {
      "close": _vm.toggleCreateDeviceDialog,
      "refreshList": _vm.refreshList
    }
  }) : _vm._e(), _vm.deviceUpdateDialog ? _c('div', [_c('niota-classic-devices-multiple-edit-form', {
    attrs: {
      "editAllFormDialog": _vm.selectedRows && _vm.selectedRows.length > 1,
      "selectedRows": _vm.selectedRows,
      "deviceTypes": _vm.deviceTypes,
      "applications": _vm.applications
    },
    on: {
      "close": _vm.toggleEditAllDialog,
      "refreshList": _vm.refreshList
    }
  })], 1) : _vm._e(), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, [_c(VRow, [_c(VCol, {
    attrs: {
      "sm": "4",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.search'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "hide-details": "auto",
      "single-line": "",
      "clearable": ""
    },
    model: {
      value: _vm.searchItem,
      callback: function ($$v) {
        _vm.searchItem = $$v;
      },
      expression: "searchItem"
    }
  })], 1), _c(VCol, {
    staticClass: "text-right",
    attrs: {
      "cols": "6",
      "sm": "8",
      "md": "6"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-plus"
    },
    on: {
      "click": _vm.toggleCreateDeviceDialog
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.addNew')) + "\n          ")]), _vm.selectedRows && _vm.selectedRows.length > 1 ? _c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-edit"
    },
    on: {
      "click": _vm.toggleEditAllDialog
    }
  }, [_vm._v("\n            " + _vm._s(this.$i18n_t('Common.editAll')) + "\n          ")]) : _vm._e()], 1)], 1), _c(VDataTable, {
    staticClass: "clickable",
    attrs: {
      "items": _vm.list,
      "loading": _vm.isFetching,
      "server-items-length": _vm.serverItemsLength,
      "options": _vm.tableOptions,
      "headers": _vm.tableHeaders,
      "footer-props": _vm.tableFooterProps,
      "item-key": "id",
      "show-select": _vm.isIotHubManager
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      },
      "input": _vm.rowSelectUpdate,
      "click:row": _vm.viewDevice
    },
    scopedSlots: _vm._u([{
      key: "item.title",
      fn: function (items) {
        return [_c('div', {
          staticClass: "text-truncate",
          attrs: {
            "title": items.item.title
          }
        }, [_c('router-link', {
          attrs: {
            "to": `/niota-classic/devices/${items.item.id}/details`
          }
        }, [_vm._v("\n              " + _vm._s(items.item.title) + "\n            ")])], 1)];
      }
    }, {
      key: "item.eui",
      fn: function (items) {
        return [_vm.isCopySupported() ? _c('div', {
          staticClass: "euiElement",
          on: {
            "click": function ($event) {
              return _vm.copyToClipboard($event, items.item.eui);
            }
          }
        }, [_c('pre', [_vm._v(_vm._s(items.item.eui))]), _c(VIcon, {
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-copy")])], 1) : _c('div', {
          staticClass: "euiElement"
        }, [_c('pre', [_vm._v(_vm._s(items.item.eui))])])];
      }
    }, {
      key: "item.createdAt",
      fn: function (items) {
        return [_vm._v("\n          " + _vm._s(_vm.localizeDate(items.item.createdAt)) + "\n        ")];
      }
    }, {
      key: "item.originator_image",
      fn: function (items) {
        return [items.item.originator_image ? _c('img', {
          staticClass: "icon",
          attrs: {
            "src": `${_vm.n1Path}${items.item.originator_image}`
          }
        }) : _vm._e(), !items.item.originator_image ? _c('img', {
          staticClass: "icon",
          attrs: {
            "src": "img/niota-classic/placeholder.png"
          }
        }) : _vm._e()];
      }
    }, {
      key: "item.operationalStatus",
      fn: function (items) {
        return [_vm._v(_vm._s(_vm.getOperationalStatus(items.item)))];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n          ")])];
      },
      proxy: true
    }, _vm.isIotHubManager ? {
      key: "item.actions",
      fn: function ({
        item
      }) {
        return [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.edit'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.editDevice(item);
            }
          }
        }, [_vm._v("\n            fal fa-edit\n          ")]), _vm._v("\n           \n          "), _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.delete'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.showDeletePrompt(item);
            }
          }
        }, [_vm._v("\n            fal fa-trash-alt\n          ")])];
      }
    } : null, {
      key: "footer.page-text",
      fn: function (items) {
        return [_vm._v("\n          " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n        ")];
      }
    }], null, true),
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };